import React, { Component } from "react";
import Chatbot from "../icons/Chatbot";

export default class ChatbotButton extends Component {
  render() {
    return (
      <div className="chatbot-button">
        <Chatbot />
      </div>
    );
  }
}
